export const eyewearExampleData = () => {
  return {
    request: {
      begin: '2022-12-12',
      end: '2023-02-21',
    },
    response: {
      skupreferences: [
        {
          category: 'EYE GLASSES',
          skuName: 'Adrian-04',
          product: 'Adrian',
          lensTint: 'Original',
          size: 'S',
          save: 1091,
          saveCTR: 0.0110344688,
          tryout: 98872,
        },
        {
          category: 'EYE GLASSES',
          skuName: 'Adrian-04',
          product: 'Adrian',
          lensTint: 'Original',
          size: 'M',
          save: 1091,
          saveCTR: 0.0110344688,
          tryout: 98872,
        },
        {
          category: 'EYE GLASSES',
          skuName: 'Adrian-04',
          product: 'Adrian',
          lensTint: 'Yellow',
          size: 'S',
          save: 1091,
          saveCTR: 0.0110344688,
          tryout: 98872,
        },
        {
          category: 'EYE GLASSES',
          skuName: 'Adrian-04',
          product: 'Adrian',
          lensTint: 'Yellow',
          size: 'M',
          save: 1091,
          saveCTR: 0.0110344688,
          tryout: 98872,
        },
        {
          category: 'EYE GLASSES',
          skuName: 'Adrian-06',
          product: 'Adrian',
          lensTint: 'Original',
          size: 'S',
          save: 999,
          saveCTR: 0.01032644,
          tryout: 96742,
        },
        {
          category: 'EYE GLASSES',
          skuName: 'Adrian-06',
          product: 'Adrian',
          lensTint: 'Original',
          size: 'M',
          save: 999,
          saveCTR: 0.01032644,
          tryout: 96742,
        },
        {
          category: 'EYE GLASSES',
          skuName: 'Adrian-06',
          product: 'Adrian',
          lensTint: 'Yellow',
          size: 'S',
          save: 999,
          saveCTR: 0.01032644,
          tryout: 96742,
        },
        {
          category: 'EYE GLASSES',
          skuName: 'Adrian-06',
          product: 'Adrian',
          lensTint: 'Yellow',
          size: 'M',
          save: 999,
          saveCTR: 0.01032644,
          tryout: 96742,
        },
        {
          category: 'SUN GLASSES',
          skuName: 'Bailey-01',
          product: 'Bailey',
          lensTint: 'Original',
          size: 'S',
          save: 734,
          saveCTR: 0.00879136673,
          tryout: 83491,
        },
        {
          category: 'SUN GLASSES',
          skuName: 'Bailey-01',
          product: 'Bailey',
          lensTint: 'Original',
          size: 'M',
          save: 734,
          saveCTR: 0.00879136673,
          tryout: 83491,
        },
        {
          category: 'SUN GLASSES',
          skuName: 'Bailey-01',
          product: 'Bailey',
          lensTint: 'Yellow',
          size: 'S',
          save: 734,
          saveCTR: 0.00879136673,
          tryout: 83491,
        },
        {
          category: 'SUN GLASSES',
          skuName: 'Bailey-01',
          product: 'Bailey',
          lensTint: 'Yellow',
          size: 'M',
          save: 734,
          saveCTR: 0.00879136673,
          tryout: 83491,
        },
      ],
    },
  };
};
